import { formatAddress, capitalizeString } from "../../../utilities/helpers";

import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";

import { DateInputWrapper } from "../../../components/DateInputWrapper";
import { TimeInputWrapper } from "../../../components/TimeInputWrapper";
import { Spinner } from "../../../components/LoadingContainer/Spinner";
import { LoadingContainer } from "../../../components/LoadingContainer";

export default function CreateSeasonModal({
  showSeason,
  loadVenues,
  isLoading,
  venues,
  room,
  formData,
  handleVenue,
  handleClose,
  handleSubmit,
  isSaving,
  handleChange,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  valid,
  alert,
}) {
  return (
    <>
      <Modal
        centered
        animation={false}
        fullscreen="md-down"
        show={showSeason}
        onHide={handleClose}
        backdrop="static"
        contentClassName="h-md"
        onShow={() => loadVenues()}
      >
        <Modal.Body className="d-flex-column">
          {isLoading ? (
            <LoadingContainer />
          ) : (
            <>
              <div className="modal-body-heading">
                <h1 className="modal-body-heading-title">Create Season</h1>
              </div>
              {alert.show && (
                <>
                  <Alert variant={alert.variant} className="mb-5">
                    <p>{alert.message}</p>
                  </Alert>
                </>
              )}
              <Form.Group className="form-group" controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter a name for season"
                  name="name"
                  onChange={handleChange}
                  value={formData?.name}
                  autoFocus
                  required
                />
              </Form.Group>
              <Form.Group className="form-group" controlId="venue">
                <div className="form-label--flex">
                  <Form.Label>Venue</Form.Label>
                </div>
                <Form.Select
                  name="venue"
                  onChange={handleVenue}
                  value={room?.uuid || ""}
                  required
                >
                  <option disabled hidden value="">
                    Select venue
                  </option>
                  {venues &&
                    venues.map((option, index) => (
                      <optgroup
                        label={`${option?.name} - ${formatAddress(option)}`}
                        key={index}
                      >
                        {option.rooms?.map((room, i) => (
                          <option value={room.uuid} data-venue={option} key={i}>
                            {capitalizeString(room.name)}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="form-group" controlId="details">
                <Form.Label>Details</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  as="textarea"
                  name="details"
                  onChange={handleChange}
                  value={formData?.details}
                />
              </Form.Group>
              <Row className="mt-5">
                <Col>
                  <DateInputWrapper
                    label="Start Date"
                    id="email-start"
                    setDate={setStartDate}
                    selectedDate={startDate}
                    startDate={new Date()}
                  />
                </Col>
                <Col>
                  <TimeInputWrapper
                    label="Start Time"
                    id="email-time"
                    setDate={setStartDate}
                    selectedDate={startDate}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <DateInputWrapper
                    label="End Date"
                    id="email-start"
                    setDate={setEndDate}
                    selectedDate={endDate}
                    startDate={startDate}
                  />
                </Col>
                <Col>
                  <TimeInputWrapper
                    label="End Time"
                    id="email-time"
                    setDate={setEndDate}
                    selectedDate={endDate}
                  />
                </Col>
              </Row>
              <Stack
                direction="horizontal"
                className="justify-content-between btn-group-flex"
              >
                <Button variant="default" size="lg" onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  size="lg"
                  className="btn-width btn-width-sm"
                  disabled={!valid || isSaving}
                  onClick={handleSubmit}
                >
                  {isSaving ? <Spinner /> : "Create"}
                </Button>
              </Stack>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
